import React from "react";
export var usePlaylistPublishStatusEdit = function (initial) {
    var _a = React.useState(initial), published = _a[0], setPublished = _a[1];
    return { value: published, set: setPublished };
};
